import { observable, computed, makeObservable } from 'mobx';
import {t} from 'shared/core';
import {DomainObject, oneOf} from 'shared/store';
import Employee from '../employees/Employee';
import CompanyDocument from './CompanyDocument';

class AssignmentRule extends DomainObject {
  assigneeType;
  employee;
  companyDocument;
  order;
  color;

  _relations = {
    employee: Employee,
    companyDocument: CompanyDocument,
    assigneeType: oneOf(['employee', 'manager', 'specific_employee'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      assigneeType: observable,
      employee: observable,
      companyDocument: observable,
      order: observable,
      color: observable,
      assignee: computed,
      name: computed,
      nameWithOrder: computed,
      isSpecificEmployee: computed,
      isEmployee: computed,
      isRemovable: computed
    });

    this.merge(other);
  }

  get assignee() {
    if (this.isSpecificEmployee) return this.employee.id;

    return this.assigneeType;
  }

  get name() {
    if (this.isSpecificEmployee) return this.employee.name;

    return t(`models.company_document.assignment_rules.${this.assigneeType}`);
  }

  get nameWithOrder() {
    return `${this.order + 1}. ${this.name}`;
  }

  get isSpecificEmployee() {
    return this.assigneeType === 'specific_employee';
  }

  get isEmployee() {
    return this.assigneeType === 'employee';
  }

  get isRemovable() {
    return !this.isEmployee;
  }
}

export default AssignmentRule;
